import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <path
      clipRule="evenodd"
      d="M20 4.5H4V20.5H20V4.5ZM2 2.5V22.5H22V2.5H2Z"
      fill="#21201F"
      fillRule="evenodd"
      opacity="0.4"
    />
    <path
      d="M9.79825 7.6425C10.1161 7.54471 10.4148 7.4968 10.6835 7.50019C11.4711 7.51014 12.0011 7.96079 12.0011 8.88847C12.0011 7.96079 12.5311 7.51015 13.3187 7.50019C13.587 7.4968 13.8853 7.54459 14.2027 7.64212C14.3286 7.69556 14.4521 7.75345 14.5731 7.81558L14.215 8.43582C13.5806 8.67967 13.1303 9.32338 13.1303 10.0437C13.1303 10.4132 13.2488 10.7551 13.45 11.0334L17.4561 7.50053C17.8055 8.27662 18 9.13756 18 10.0439C18 12.9449 16.2121 15.3807 13.5213 16.058L14.5737 17.8808C13.8025 18.277 12.928 18.5005 12.0014 18.5005C11.0753 18.5005 10.2013 18.2772 9.43043 17.8815L10.4833 16.0579C7.79311 15.3802 6 12.9447 6 10.0441C6 9.13774 6.19444 8.2768 6.54387 7.50071L10.5556 11.0333C10.7561 10.7553 10.8742 10.4139 10.8742 10.045C10.8742 9.32438 10.4236 8.68047 9.78878 8.43682L9.42981 7.81506C9.55018 7.75327 9.67305 7.69569 9.79825 7.6425Z"
      fill="#21201F"
    />
  </>,
  'RussianPostIcon',
)
